import "@diligentcorp/atlas-web-component-icons/lib/expand-down/index.js";
import "@diligentcorp/atlas-web-component-icons/lib/expand-right/index.js";
import "@diligentcorp/atlas-web-component-icons/lib/expand-left/index.js";
import { css, html, LitElement } from "lit";
import { appSwitcherItem, transition } from "../styles.js";
export class NavItem extends LitElement {
    constructor() {
        super();
        this.renderExpandLeftIcon = () => {
            return html `<dil-expand-left-icon aria-hidden="true"></dil-expand-left-icon>`;
        };
        this.renderExpandRightIcon = () => {
            return html `<dil-expand-right-icon aria-hidden="true"></dil-expand-right-icon>`;
        };
        this.renderExpandDownIcon = () => {
            return html `<dil-expand-down-icon aria-hidden="true"></dil-expand-down-icon>`;
        };
        this.label = "";
        this.isCurrent = false;
        this.isHighlighted = false;
    }
    renderContents() {
        return html `
      <span class="icon">
        <slot name="icon"></slot>
      </span>
      <span class="label">${this.label}</span>
    `;
    }
    get itemClasses() {
        return {
            item: true,
            transition: true,
            current: this.isCurrent,
            highlighted: this.isHighlighted,
        };
    }
}
NavItem.properties = {
    label: { type: String, reflect: true, attribute: true },
    isCurrent: { type: Boolean, reflect: true, attribute: "is-current" },
    isHighlighted: { type: Boolean, reflect: true, attribute: "is-highlighted" },
};
NavItem.shadowRootOptions = {
    mode: "open",
    delegatesFocus: true,
};
NavItem.styles = [
    transition,
    appSwitcherItem,
    css `
      :host {
        display: contents;
      }
      ::slotted(span) {
        display: inline-flex;
      }
    `,
];
